import { $t } from '@/navbar/i18n'

export default {
  all_apps_url: 'https://platform.ecoonline.com',
  explore_more_url: 'https://www.ecoonline.com',
  get header_text() { return $t('navbar.ad.headerText') },
  get body_text() { return $t('navbar.ad.bodyText') },
  namespaces: [
    {
      identifier: 'ehs',
      marketing_url: 'https://www.ecoonline.com/ehs-software/',
      products: ['ehs'],
    },
    {
      identifier: 'crisis',
      marketing_url: 'https://www.ecoonline.com/ehs-software/emergency-response-software/',
      products: ['team_manager', 'operations_center'],
    },
    {
      identifier: 'loneworker',
      marketing_url: 'https://www.ecoonline.com/ehs-software/lone-worker/',
      products: ['staysafe'],
    },
    {
      identifier: 'esg',
      marketing_url: 'https://www.ecoonline.com/esg-software/',
      products: ['ecometrica'],
    },
    {
      identifier: 'permits',
      marketing_url: 'https://www.ecoonline.com/ehs-software/control-of-work/permit-to-work-software/',
      products: ['epermits'],
    },
    {
      identifier: 'training',
      marketing_url: 'https://www.ecoonline.com/safety-learning-management-system/',
      products: ['munio'],
    },
    {
      identifier: 'chemical',
      marketing_url: 'https://www.ecoonline.com/chemical-safety/chemical-management-software/',
      products: ['chemical_manager'],
    },
    {
      identifier: 'coshh',
      marketing_url: 'https://www.ecoonline.com/chemical-safety/coshh-risk-assessment/',
      products: ['sypol'],
    },
    {
      identifier: 'sds-auth',
      marketing_url: 'https://www.ecoonline.com/chemical-safety/sds-authoring/',
      products: ['almego'],
    },
    {
      identifier: 'sds-dist',
      marketing_url: 'https://www.ecoonline.com/chemical-safety/chemical-distribution-software/',
      products: ['reseller'],
    },
  ],
}
